import { Colors, Storage } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';
import { Input } from '@lightningjs/ui-components';
// import { InputField } from '@lightningjs/ui';

export default class ProfileName extends Lightning.Component {
  static _template() {
    return {
      Content: {
        InputContainer: {
          y: 330,
          x: 360,
          w: 600,
          h: 55,
        },
        Labels: {
          color: Colors('#fafafa').get(),
          InputWrapper: {
            y: 330,
            x: 330,
            Input: {
              type: Input,
              y: 5,
              x: 5,
              w: 685,
              h: 57,
              style: {
                backgroundColor: Colors('#000000').alpha(1).get(),
                textStyle: {
                  textColor: Colors('#D6D6D6').alpha(1).get(),
                  fontSize: 36,
                  fontFace: 'OpenSans-Regular',
                },
                cursorStyle: {
                  textColor: Colors('#D6D6D6').alpha(1).get(),
                },
              },
            },
          },
        },
        Placeholder: {
          w: 695,
          h: 67,
          x: 365,
          y: 340,
          text: { text: 'Enter your name', fontSize: 36, fontFace: 'OpenSans-Regular' },
          color: Colors('#D6D6D6').alpha(0.9).get(),
        },
      },
      Border: {
        x: 316,
        y: 320,
        collision: true,
        texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#000000').get(), false),
      },
    };
  }

  _enable() {
    super._active();
    this.tag('Input').color = Colors('#d6d6d6').get();
  }

  get _ProfileName() {
    return this.tag('Input');
  }
  get _Border() {
    return this.tag('Border');
  }

  _changePlaceholder() {
    const isInputEmpty = this.tag('Input').value === '';
    this.tag('Placeholder').patch({
      visible: isInputEmpty,
    });
  }

  _focus() {
    this._ProfileName.patch({
      color: Colors('#fafafa').get(),
    });
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#02AC25').get(), false),
    });
  }
  _unfocus() {
    this._ProfileName.patch({
      color: Colors('#D6D6D6').get(),
    });
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#000000').get(), false),
    });
  }

  // Magic Remote
  _handleHover() {
    this.fireAncestors('$setState', 'ProfileName');
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }
}
